import { Box, Link } from '@mui/material';
import { useStyles } from './styles';
import AxleHireSupport from '../AxlSupport';
import DEFAULT_LOGO from '../../assets/svg/Jitsu-color.svg';
import MOBILE_LOGO from '../../assets/svg/Jitsu.svg';
import AccommodationsEmail from 'components/AccommodationsEmail';

function Footer({
  styles: propStyles,
  clientLogo,
  clientTitle,
  clientPhone,
  clientEmail,
  showAxlehireSupport,
  axlehireTitle,
  axlehireEmail,
  axlehirePhone,
}) {
  const classes = useStyles();

  return (
    <Box sx={classes.footerContainer} style={propStyles}>
      <Box mx="auto" sx={classes.footerWrapper}>
        <Box py={1} sx={classes.footerHelp}>
          <Box sx={classes.title}>Need help?</Box>
          <AxleHireSupport title={clientTitle} phone={clientPhone} email={clientEmail} />
          {showAxlehireSupport && <AxleHireSupport title={axlehireTitle} phone={axlehirePhone} email={axlehireEmail} />}
          <AccommodationsEmail />
        </Box>
        <Box py={3}>
          <Box sx={classes.footerLogoContainer}>
            <Box component="img" src={clientLogo || DEFAULT_LOGO} alt="Jitsu" sx={classes.footerLogo} height={52} />
            <Box component="img" src={MOBILE_LOGO} alt="Jitsu" sx={classes.footerLogoMobile} />
            {!clientLogo && (
              <Box component="span" sx={classes.footerBrand}>
                Jitsu
              </Box>
            )}
          </Box>
          <Box sx={classes.copyright}>
            <span>&copy; {new Date().getFullYear()} Jitsu. All rights reserved.</span>
            <Box display="inline-flex" sx={{ ml: 0.5 }} gap={1}>
              <Link href={import.meta.env.REACT_APP_PRIVACY_URL} target="_blank" rel="noopener noreferrer" underline="hover" sx={classes.hyperLink}>
                Privacy Policy
              </Link>
              <span>|</span>
              <Link href={import.meta.env.REACT_APP_TERMS_URL} target="_blank" rel="noopener noreferrer" underline="hover" sx={classes.hyperLink}>
                Terms
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Footer;
